// Design tokens — single source of truth for navigation visual constants.
// Extracted from the original VerticalNavigationBar.tsx. Any visual fix goes here.

export const COLLAPSED_WIDTH = 280; // 64px if we're going to collapse the nav, but for now we are keeping it expanded by default
export const EXPANDED_WIDTH = 280;

export const NAV_TRANSITION = '350ms cubic-bezier(0.4, 0, 0.2, 1)';

export const NAV_TEXT_COLOR = 'var(--color-ink)';
export const NAV_HOVER_BG_MAIN = 'var(--color-bg-hover-nav)';
export const NAV_HOVER_BG_SUB = 'var(--color-bg-hover-muted)';
export const NAV_FOCUS_COLOR = 'var(--color-focus)';
export const NAV_BG = 'var(--color-bg-surface)';
export const ITEM_BORDER = 'var(--color-border-subtle)';

export const FONT_FAMILY = 'EnterpriseSansVF, Arial, sans-serif';
export const FONT_WEIGHT = 400;

export const ICON_SIZE = 24;
